<template>
    <UploadCard
        api-endpoint="/image/flowUpload"
        :upload-params="uploadParams"
        :height="height"
        :width="width"
        allowed-types="image/*"
        @uploaded="afterImageUploaded"
    >
        <template #upload-action-btn>
            <KpIcon icon-cls="upload" color="white" disabled-color="grey" />
            {{ $t('upload_img') }}
        </template>
    </UploadCard>
</template>

<script>
/**
 * This component declares a simple card to drop an image. The image then is uploaded
 * to [backend]/image/flowUpload, and stored.
 *
 * You can pass additional query props using the "uploadParams" object. This info
 * is just added to the upload request.
 *
 * If the upload of (all) image(s) were successful, the 'uploaded' event is
 * fired, with instantiated "Image" objects as parameter.
 *
 */
import UploadCard from './UploadCard.vue';

export default {
    name: 'ImageUploadCard',
    components: {
        UploadCard,
    },
    props: {
        width: {
            type: String,
            default: '200px',
        },
        height: {
            type: String,
            default: '150px',
        },
        uploadParams: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        afterImageUploaded(images, flowFiles) {
            this.$emit('uploaded', images, flowFiles);
        },
    },
};
</script>

<style lang="scss" scoped></style>
